export default __webpack_public_path__ + "static/media/icon_donation.4d1cdb6f.svg";